module.exports = __webpack_public_path__ + "img/8-about.ceb78db1.jpg";